/** @flow */

import React, { useRef } from "react";
import { Button, View, SchemaForm } from "@components";
import { localize } from "redux-i18n";
import "./style.scss";
import { compose } from "redux";

type Props = $Exact<{
  ...PropsFromLocalize,
  currentPage: number,
  pagesCount: number,
  showingOption: string,
  className?: string,
  groupedBy: string,
  toggleModalOptions: () => void,
  onSearchTasksChange: Function,
  searchValue: string,
  tasksType: string | null,
  filterSubmit: Function,
  filtersData: TasksQueueFilterProps | null,
}>;

export type TasksQueueFilterProps = {
  search: string | null,
  taskType: string,
  showDirectReportsOnly: string,
  orderBy: string,
};

function TasksQueueFilter(props: Props) {
  const formRef = useRef(null);

  const TaskFilterSchema = {
    type: "object",
    properties: {
      search: { type: "string" },
      taskType: {
        type: "string",
        oneOf: [
          {
            title: props.t("ALL"),
            const: "",
          },
          {
            title: props.t("RTW"),
            const: "RTW_INTERVIEW",
          },
          {
            title: props.t("MONITORING"),
            const: "ABSENCE_MONITORING_REVIEW",
          },
          {
            title: props.t("REFERRALS"),
            const: "MANAGER_REFERRAL_DECISION",
          },
        ],
      },
      showDirectReportsOnly: {
        type: "string",
        oneOf: [
          {
            title: props.t("YES"),
            const: "YES",
          },
          {
            title: props.t("NO"),
            const: "NO",
          },
        ],
      },
      orderBy: {
        type: "string",
        oneOf: [
          {
            title: props.t("DUE_DATE"),
            const: "due_date",
          },
          {
            title: props.t("EMPLOYEE_NAME"),
            const: "employee",
          },
          {
            title: props.t("TASK_TYPE"),
            const: "task_type",
          },
        ],
      },
    },
  };

  const TaskFilterUiSchema = {
    search: {
      "ui:title": props.t("SEARCH"),
      "ui:options": { labelposition: "top" },
    },
    taskType: {
      "ui:title": props.t("TASK_TYPE"),
      "ui:options": { labelposition: "top" },
    },
    showDirectReportsOnly: {
      "ui:title": props.t("DIRECT_REPORTS_ONLY"),
      "ui:options": { labelposition: "top" },
    },
    orderBy: {
      "ui:title": props.t("ORDER_BY"),
      "ui:options": { labelposition: "top" },
    },
  };

  const data = {
    ...props.filtersData,
    showDirectReportsOnly: props.filtersData?.showDirectReportsOnly ? "YES" : "NO",
  };

  function submitForm() {
    formRef.current.submit();
  }

  function handleSubmit(formData: Object) {
    props.filterSubmit({
      ...data,
      ...formData,
      showDirectReportsOnly: formData.showDirectReportsOnly === "YES",
    });
  }

  return (
    <>
      <View direction="row" gap={4} justifyContent="center" alignItems="flex-end">
        <SchemaForm
          ref={formRef}
          schema={TaskFilterSchema}
          onSubmit={handleSubmit}
          formData={data}
          uiSchema={TaskFilterUiSchema}
          columns={4}
          externalSubmit
          className="tasks-queue-filter"
        />
        <View justifyContent="center" padding={[0, 0, "4x", 0]}>
          <Button materialIcon="replay_circle_filled" onClick={submitForm} className="mb-1">
            {props.t("SUBMIT")}
          </Button>
        </View>
      </View>
    </>
  );
}

export default compose(localize())(TasksQueueFilter);
